export const basicAuth = {
  username: "Rajneesh@example.com",
  password: "Test@12345",
};
